import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

type PageFieldProps = {
  children: React.ReactNode;
};

/** Intro surface: a brand wash and a faint grid. Reading sections stay on the plain page. */
const PageField = ({ children }: PageFieldProps) => {
  const theme = useTheme();
  const dark = theme.palette.mode === 'dark';

  const wash = dark
    ? 'radial-gradient(ellipse 72% 90% at 0% 0%, rgba(62, 166, 255, 0.28), transparent 58%), radial-gradient(ellipse 46% 60% at 100% 100%, rgba(0, 102, 178, 0.22), transparent 52%)'
    : 'radial-gradient(ellipse 72% 90% at 0% 0%, rgba(0, 102, 178, 0.16), transparent 60%), radial-gradient(ellipse 40% 50% at 100% 0%, rgba(0, 102, 178, 0.08), transparent 48%)';

  const grid = dark
    ? 'linear-gradient(rgba(62, 166, 255, 0.22) 1px, transparent 1px), linear-gradient(90deg, rgba(62, 166, 255, 0.22) 1px, transparent 1px)'
    : 'linear-gradient(rgba(0, 102, 178, 0.16) 1px, transparent 1px), linear-gradient(90deg, rgba(0, 102, 178, 0.16) 1px, transparent 1px)';

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        bgcolor: 'background.default',
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Box
        aria-hidden
        sx={{
          pointerEvents: 'none',
          position: 'absolute',
          inset: 0,
          background: wash,
        }}
      />
      <Box
        aria-hidden
        sx={{
          pointerEvents: 'none',
          position: 'absolute',
          inset: 0,
          opacity: dark ? 0.45 : 0.55,
          backgroundImage: grid,
          backgroundSize: '56px 56px',
          maskImage: 'radial-gradient(ellipse at 12% 0%, #000 0%, transparent 70%)',
          WebkitMaskImage: 'radial-gradient(ellipse at 12% 0%, #000 0%, transparent 70%)',
        }}
      />
      <Box
        aria-hidden
        sx={{
          pointerEvents: 'none',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '2px',
          zIndex: 2,
          bgcolor: dark ? '#ff3d5c' : '#dc052d',
        }}
      />
      <Box sx={{ position: 'relative' }}>{children}</Box>
    </Box>
  );
};

export default PageField;
